module.exports = __webpack_public_path__ + "img/check.fe8bebe9.svg";